module.exports = __webpack_public_path__ + "img/10.971fe5ae.jpg";